import React from 'react';
import orderBy from 'lodash/orderBy';
import PropTypes from 'prop-types';
import { Spinner, Icon } from 'ui';
import GradingStationCard from './GradingStationCard';

const shouldShowBlankSlate = ({
  loading,
  filtersLoading,
  hasProgresses,
  currentGradableOptions,
}) =>
  !filtersLoading &&
  !loading &&
  !hasProgresses &&
  !(currentGradableOptions && currentGradableOptions.length > 0);

const GradingStationList = ({
  hasProgresses,
  progresses,
  loading,
  filtersLoading,
  gradableType,
  currentGradableName,
  currentGradableOptions,
  ziggeoApiKey,
  currentUser,
  stalenessThreshold,
  markProgressGraded,
}) => {
  const showBlankSlate = shouldShowBlankSlate({
    loading,
    filtersLoading,
    hasProgresses,
    currentGradableOptions,
  });

  if (loading) {
    return (
      <div className="FlexPanel-row">
        <div className="FlexPanel-solo p-32">
          <Spinner large />
        </div>
      </div>
    );
  }

  if (showBlankSlate) {
    if (gradableType === 'group') {
      return (
        <div className="p-16 border-gray-light border bg-white d-f jc-c fd-c ai-c minh-300 h-100p mt-16">
          <Icon name="thumbsup_sparkle" className="h-70 w-110" />
          <h2 className="ff-ss fz-24 lh-32 fw-b">
            {t('grades.groups_blank_slate.title')}
          </h2>
          <p className="ff-ss fz-18">
            {t('grades.groups_blank_slate.description')}
          </p>
        </div>
      );
    }

    return (
      <div className="p-16 border-gray-light border bg-white d-f jc-c fd-c ai-c minh-300 h-100p mt-16">
        <Icon name="thumbsup_sparkle" className="h-70 w-110" />
        <h2 className="ff-ss fz-24 lh-32 fw-b">
          {t('grades.new_blank_slate.title')}
        </h2>
        <p className="ff-ss fz-18 d-f fd-c ai-c">
          <span>{t('grades.new_blank_slate.description')}</span>
          <span>{t('grades.new_blank_slate.description_two')}</span>
        </p>
      </div>
    );
  }

  return (
    <div className="mt-32">
      {hasProgresses && !loading && (
        <>
          {gradableType !== 'long-waiting' && currentGradableName && (
            <h2 className="c-gray-darkest fz-24 fw-b mb-24 ff-ss">
              {currentGradableName}
            </h2>
          )}
          {orderBy(progresses, ['daysAwaitingGrade'], ['desc']).map(
            progress => (
              <GradingStationCard
                key={progress.id}
                progress={progress}
                ziggeoApiKey={ziggeoApiKey}
                currentUser={currentUser}
                stalenessThreshold={stalenessThreshold}
                gradableType={gradableType}
                markProgressGraded={markProgressGraded(progress.id)}
              />
            ),
          )}
        </>
      )}
    </div>
  );
};

GradingStationList.propTypes = {
  hasProgresses: PropTypes.bool,
  filtersLoading: PropTypes.bool,
  progresses: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
    }),
  ),
  currentGradableName: PropTypes.string,
  currentGradableOptions: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string,
    }),
  ),
  ziggeoApiKey: PropTypes.string,
  currentUser: PropTypes.string,
  stalenessThreshold: PropTypes.number,
  gradableType: PropTypes.string,
  markProgressGraded: PropTypes.func,
};

export default GradingStationList;
